import React from 'react';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import { useCollections } from 'Providers/CollectionsProviders';
import './styles.css';
import { changeMoney } from 'Providers/DolarProvider';
import { CURRENCY } from 'Providers/PaymentCurrencyProvider';
import { instance } from 'services/api';

export default function PayPalCheckout({
  goToPaypalPayment,
  orderPaymentButtonDisabled,
}) {
  const { shoppingCart } = useCollections();

  const initialOptions = {
    'client-id': process.env.REACT_APP_PAYPAL_CLIENT_ID,
    'disable-funding': 'card,credit,paylater,venmo',
    currency: 'USD',
    'data-page-type': 'product-details',
    components: 'buttons',
    'data-sdk-integration-source': 'developer-studio',
  };

  const createOrder = async (data, actions) => {
    try {
      await goToPaypalPayment();
    } catch (error) {
      /* empty */
    }
  };

  const onApprove = async (data, actions) => {
    // console.log({ data, actions });
  };

  const stylesPaypalButtons = {
    color: 'blue',
    shape: 'rect',
    label: 'paypal',
    height: 40,
  };
  return (
    <div style={{ width: '100%', paddingTop: '8px' }}>
      <PayPalScriptProvider options={initialOptions}>
        <PayPalButtons
          className="paypalButtons"
          disabled={orderPaymentButtonDisabled}
          style={stylesPaypalButtons}
          fundingSource="paypal"
          createOrder={createOrder}
          onApprove={onApprove}
        />
      </PayPalScriptProvider>
    </div>
  );
}
